import { IWhoAmIResponse } from "../model/Usuario";

const USER_SESSION_KEY: string = "userSession";

export const saveUserSession = (userData: IWhoAmIResponse): void => {
  sessionStorage.setItem(USER_SESSION_KEY, JSON.stringify(userData));
};

export const getUserSession = (): IWhoAmIResponse | null => {
  const userData = sessionStorage.getItem(USER_SESSION_KEY);
  if (!userData) {
    return null;
  }
  try {
    return JSON.parse(userData) as IWhoAmIResponse;
  } catch (error) {
    return null;
  }
};

export const getUserId = (): string | null => {
  const userData = getUserSession();
  return userData?.id || null;
};

export const getUserName = (): string | null => {
  const userData = getUserSession();
  return userData?.nome || null;
};

export const clearUserSession = (): void => {
  sessionStorage.removeItem(USER_SESSION_KEY);
};

export const clearAuthData = (): void => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  clearUserSession();
};
